import { useInfiniteQuery, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { getAuditLogs } from '../services/auditLogService';
import { AuditLogSchema, TGetAuditLogsParams, TGetAuditLogsResponse } from '../types/audit-log';

const useGetAuditLogs = (
  params?: TGetAuditLogsParams,
  options?: Partial<UseInfiniteQueryOptions<TGetAuditLogsResponse, any, any, any>>
) => {
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    isPending,
    status,
    isError,
    refetch,
  } = useInfiniteQuery({
    queryKey: ['audit-logs', params],
    queryFn: async ({ pageParam }) =>
      getAuditLogs({
        next_cursor: pageParam as string | undefined,
        ...(params || {}),
      }),
    initialPageParam: '',
    getNextPageParam: (lastPage) => lastPage?.next_cursor,
    select: (data) => data?.pages.flatMap((page) => page.audit_logs) as unknown as AuditLogSchema[],
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    staleTime: 2 * 60 * 1000,
    ...(options || {}),
  });

  return {
    data: (data as unknown as AuditLogSchema[]) || [],
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isPending,
    isFetchingNextPage,
    isError,
    status,
    refetch,
  };
};

export default useGetAuditLogs;


